/**
 * Il contenitore dei toast (Sonner), montato una volta sola sopra l'app.
 *
 * Il tema lo prende da `useTema`, non da next-themes come farebbe il
 * componente da solo: l'app ha il suo provider. In alto al centro, perché in
 * basso su telefono c'è la barra di navigazione. Quando usare un toast e
 * quando un box in pagina è in `docs/navigazione-e-viste.md`, §1.12.
 */

import { Toaster } from '@/components/ui/sonner';
import { useTema } from '../tema/contesto.js';

export function Notifiche() {
  const { modo } = useTema();
  return <Toaster theme={modo === 'scuro' ? 'dark' : 'light'} position="top-center" />;
}
